export type CbPartType = 'static' | 'random_string' | 'random_number' | 'random_base64';

export interface CbPartConfig {
  // random_string
  lowercase?: boolean;
  digits?: boolean;
  uppercase?: boolean;
  special_chars?: boolean;
  custom_chars?: string;
  // random_number
  allow_leading_zeros?: boolean;
  range_mode?: boolean;
  min_value?: number;
  max_value?: number;
  // random_base64
  url_safe?: boolean;
  // shared
  min_l?: number;
  max_l?: number;
}

export interface CbPart {
  type: CbPartType;
  value?: string;        // for static
  config?: CbPartConfig; // for random types
}

export interface CbParam {
  key: CbPart;
  value: CbPart;
}

export interface PayloadFunction extends CbPart {
  id: number; // matches §N§
}

export const CB_PART_LABELS: Record<CbPartType, string> = {
  static: 'Static',
  random_string: 'Random String',
  random_number: 'Random Number',
  random_base64: 'Random Base64',
};

export const defaultCbPart = (type: CbPartType): CbPart => {
  if (type === 'static') return { type, value: '' };
  if (type === 'random_string') return { type, config: { min_l: 8, max_l: 14, lowercase: true, digits: true, uppercase: false, special_chars: false, custom_chars: '' } };
  if (type === 'random_number') return { type, config: { min_l: 8, max_l: 14, allow_leading_zeros: false, range_mode: false, min_value: 0, max_value: 99999 } };
  return { type, config: { min_l: 8, max_l: 14, url_safe: false } }; // random_base64
};

export const defaultPayloadFunction = (id: number): PayloadFunction => ({
  ...defaultCbPart('random_string'),
  id,
});

export const PAYLOAD_PLACEHOLDER_CHAR = '§';
export const PAYLOAD_PLACEHOLDER_REGEX = /§(\d+)§/g;
